// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".wrapper[data-v-9128f34a]{background-color:#fff;padding:0}", ""]);
// Exports
module.exports = exports;
